module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/lookup-management/country/country-detail/country-detail.component.css
// module id = ./src/app/admin/lookup-management/country/country-detail/country-detail.component.css
// module chunks = main